import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { deleteConsignorData } from '_services/accountsServices/consignorServices';
import StorageService from "utils/StorageServices/StorageServices";
import toast from 'react-hot-toast';
import { Link, useNavigate } from 'react-router-dom';
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { deleteZoneData, getZoneListData } from '_services/accountsServices/zoneServices';
import moment from 'moment';
import BootstrapTable from 'components/BootstrapTable';
import { BsThreeDotsVertical } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { FaRegTrashCan } from "react-icons/fa6";
import MastersFilterModal from 'modals/MastersFilterModal';
import { constant } from 'constants/constant';
import { deleteVehicleGroupData, getVehicleGroupListData } from '_services/accountsServices/vehicleGroupServices';
import { UserContext } from 'context';
import useDocumentTitle from 'hooks/useDocumentTitle';
import AddEditVehicleDocTypeModel from 'modals/AddEditVehicleDocTypeModel/AddEditVehicleDocTypeModel';
import { deleteVehicleDocData, getVehicleDocTypeListData } from '_services/accountsServices/vehicleDocTypeServices';
import { CiLock, CiUnlock } from 'react-icons/ci';
import { deleteItems, deletePurchaseBill, deleteStore, getItemsList, getLisOfPurchaseBill, getStoreList } from '_services/workShopServices/workShopServices';
import AddEditStoreModel from 'modals/AddEditStoreModel';
import { WorkshopAddItem } from 'modals';
import '../../WorkShop/workshop.css'
import { utils } from 'helper';
import { ButtonHeading, CommonModal, CityDropdownForTrip, CommonDateRange, CommonInput, CustomPagination, CustomSelect } from 'components';
import { StorageServices } from 'utils';
import { venderDropdownApi } from '_services';

const PurchaseBill = () => {

  const ITEMS_PER_PAGE = 20
  const DEBOUNCE_DELAY = 500;
  const isResetting = useRef(false);
  const isInitialMount = useRef(true);
  const initailFilter = {
    company_id: StorageServices.getCompanyId(),
    limit: ITEMS_PER_PAGE,
    offset: 1,
    start_date: '', // moment().startOf("month").format("YYYY-MM-DD"),
    end_date: '',  // moment().endOf("month").format("YYYY-MM-DD"),
    vendor_id: {},
    status: "",
    search: "",
  }

  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [resetKey, setResetKey] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const [serviceList, setServiceList] = useState([])
  const [filter, setFilter] = useState(initailFilter)
  const [selectedRange, setSelectedRange] = useState({
    startDate: '', // moment().startOf("month")
    endDate: '', // moment().endOf("month")
  });

  useDocumentTitle("PurchaseBill | T360");
  const { settingChild } = useContext(UserContext);
  const settingChildVehicleGrp = settingChild?.find((i) => i?.label === "Vehicle Group");
  const [purchaseBillList, setPurchaseBillList] = useState([])
  const [loading, setLoading] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const prevFilterRef = useRef();

  const toggleItemsModelData = () => {
    navigate('/PurchaseBill/addBill')
  };

  useEffect(() => {
    getServiceHandle()
  }, [filter])

  useEffect(() => {
    if (isResetting.current) {
      isResetting.current = false;
      return;
    }

    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    const delayTimer = setTimeout(() => {
      setFilter((prev) => ({
        ...prev,
        search: searchInput,
        offset: 1,
      }));
      return () => clearTimeout(delayTimer);
    }, DEBOUNCE_DELAY);

    return () => clearTimeout(delayTimer);
  }, [searchInput]);

  const getServiceHandle = async () => {
    setLoading(true);
    const payload = {
      // start_date: filter?.start_date,
      // end_date: filter?.end_date,
      // search: filter?.search,
      // vendor_id: filter?.vendor_id?.value,
      // status: filter?.status,
      company_id: StorageServices.getCompanyId(),
      limit: filter?.limit,
      offset: filter?.offset,
    }
    if (filter?.start_date && filter?.end_date) {
      payload["start_date"] = filter?.start_date;
      payload["end_date"] = filter?.end_date;
    }
    if (filter?.search) {
      payload["search"] = filter?.search;
    }
    if (filter?.vendor_id?.value) {
      payload["search"] = filter?.vendor_id?.value;
    }
    if (filter?.status) {
      payload["status"] = filter?.status;
    }
    try {
      const res = await getLisOfPurchaseBill(payload);
      if (res?.responseCode == 200) {
        setPurchaseBillList(res?.data?.itemData);
        setTotalItems(res?.data?.total_record);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }

  const paymentStatusOptions = [
    { label: "Pending", value: "Pending" },
    { label: "Completed", value: "Completed" },
    { label: "Partially Paid", value: "Partially Paid" },
  ];

  const handleApply = (newRange) => {
    setSelectedRange(newRange);
    setFilter((prev) => ({
      ...prev,
      start_date: moment(newRange.startDate).format("YYYY-MM-DD"),
      end_date: moment(newRange.endDate).format("YYYY-MM-DD"),
      offset: 1,
    }));
  };

  const handleReset = () => {
    isResetting.current = true;
    setFilter(initailFilter);
    setSelectedRange({
      startDate: '',
      endDate: '',
    })
    setSearchInput("")
  };

  const handlePageChange = (page) => {
    setFilter((prev) => ({ ...prev, offset: page }));
  };

  const fetchVendor = useCallback(async (search, page, limit) => {
    try {
      const response = await venderDropdownApi({
        company_id: StorageService.getCompanyId(),
        offset: page,
        limit,
        search,
      });

      if (response?.responseCode === 200) {
        const vendors = response.data.vendor_list.map(vendor => ({
          ...vendor,
          label: vendor.name,
          value: vendor._id
        }));

        return {
          items: vendors,
          total: response.data.total_record || vendors.length,
        };
      }

      toast.error(response?.responseMessage);
      return { items: [], total: 0 };
    } catch (error) {
      console.error("Error fetching vendors:", error);
      return { items: [], total: 0 };
    }
  }, []);

  const deleteHandler = (item) => {
    setIsDelete(item)
  }

  const submitDeleteItems = async (itemData) => {
    setLoading(true);
    try {
      let object = {}
      if (itemData?.disable) {
        object['id'] = itemData?._id;
        object['status'] = (itemData?.status === 1) ? 3 : 1;
      } else {
        object['id'] = isDelete?._id;
        object['status'] = 2;
      }
      const res = await deletePurchaseBill(object);
      if (res?.responseCode == 200) {
        toast.success(`${res?.responseMessage}`);
        getServiceHandle();
        setLoading(false);
        setIsDelete(false);
      } else {
        if (res?.responseMessage) {
          toast.error(res?.responseMessage);
        }
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  }

  let propsObject = {
    isOpen: isDelete,
    closeModal: setIsDelete,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancleTitle: "Close",
    onSubmit: submitDeleteItems,
    isLoadding: loading,
  }

  const columns = [
    { header: "Bill Date", accessor: "bill_date" },
    { header: "Vendor", accessor: "vendor_id" },
    { header: "Invoice Number", accessor: "invoice_number" },
    { header: "Sub Total", accessor: "sub_total" },
    { header: "Total Amount", accessor: "total_amount" },
    { header: "TDS Balance", accessor: "tds" },
    // { header: "Payment Mode", accessor: "payment_mode" },
    { header: "Bill Status", accessor: "service_status" },
    { header: "Action", accessor: "action" },
  ];

  const rowListData = (data) => {
    return data?.map((item, i) => ({
      ...item,
      bill_date: <>{item?.createdAt ? utils?.formateDateCalander(item?.createdAt) : "-"} </>,
      payment_mode: <> {item?.payment_mode ? 'Partial Payment' : 'Full Payment'} </>,
      //  <span className='_tblText _style_ancer' onClick={(e) => { }}>
      //   <a className='_avPointer'>
      //     {item?.payment_mode ? 'Partial Payment' : 'Full Payment'}
      //   </a>
      // </span>,
      vendor_id: <>{item?.vendor_id?.name ? item?.vendor_id?.name : '-'}</>,
      add_invoice: <>{+item?.add_invoice ? <span className='green'> On </span> : <span className='red'> Off </span>}</>,
      invoice_number: <>{item?.invoice_number ? item?.invoice_number : '-'}</>,
      is_gst_chareged: <>{item?.is_gst_chareged ? 'On' : 'Off'}</>,
      payment_type: <> - </>,
      sub_total: <> &#x20B9; {item?.sub_total ? item?.sub_total : 0}</>,
      tds: <> &#x20B9; {item?.tds ? item?.tds : 0}</>,
      total_amount: <> &#x20B9; {item?.total_amount ? item?.total_amount : 0}</>,
      service_status: <span className='bg_colr_pending'> {item?.status ? constant.billStatus_bill?.find((i) => i?.value == item?.status)?.label : '-'} </span>,
      action: (
        <React.Fragment>
          <button
            className="dropbtn11"
            style={{
              border: "none",
              background: "#F3F6FF",
              color: "#0049D7",
              fontSize: "14px",
              padding: "5px 20px",
              width: "auto",
              borderRadius: "5px"
            }}
          >
            Add Payment
          </button>
        </React.Fragment>
      ),
      // (
      //   <div
      //     className="_anvSwitcherNew form-check form-switch"
      //     style={{ width: "100px" }}
      //   >
      //     <div
      //       // onClick={(e) => setShowAddItem(item)}
      //       className='_avPointer'
      //     >
      //       <span className='_samAnchor'>
      //         <span className='editIcon_avt'>
      //           <FiEdit color='blue' />
      //         </span>
      //       </span>
      //       {/* Edit */}
      //     </div>

      //     <div
      //       onClick={(e) => deleteHandler(item)}
      //       className='_avPointer'
      //     >
      //       <span className='_samAnchor'>
      //         <span className='deleteIcon_avt'>
      //           <FaRegTrashCan color='red' />
      //         </span>
      //       </span>
      //       {/* Delete */}
      //     </div>

      //     <div
      //       onClick={(e) => { }}
      //       className='_avPointer'
      //     >
      //       <span className='_samAnchor'>
      //         <span className='viewIcon_avt'>
      //           <AiOutlineEye />
      //         </span>
      //       </span>
      //     </div>
      //   </div>
      // ),
    }));
  };

  const isDisabled =
    !filter?.start_date && !filter?.end_date &&
    !searchInput &&
    !filter?.vehicle_id?._id &&
    !filter?.vendor_id?.value &&
    !filter?.status;

  return (
    <div className="__profilCmp_main">
      <ButtonHeading
        title={"Purchase Bill"}
        onClick={toggleItemsModelData}
        buttonTitle="Add Purchase Bill"
        // buttonTitle={settingChildVehicleGrp?.create === 1 && "Add Vehicle Group"}
        showSearchFilter={{ search: false, filterOption: false, filterCount: true }}
        onClickFilterModal={(e) => { }}
        filter={filter}
        setFilter={setFilter}
        isDebouncedSearch={false}
      />

      <div className='pr_procssBx' id="addPartyContent" style={{ margin: '0px' }}>
        <div className='pr_procssBx_grid'>
          <div>
            <CommonDateRange
              key={resetKey}
              initialStartDate={selectedRange.startDate || ""}
              initialEndDate={selectedRange.endDate || ""}
              onApply={handleApply}
              datePrefield={!!(selectedRange.startDate && selectedRange.endDate)}
            />
          </div>

          <div style={{ flex: '0 0 220px' }}>
            <CustomSelect
              options={paymentStatusOptions}
              name="bill_status"
              flotingLabel="Bill Status"
              placeholder="Bill Status"
              onSelect={(data) => setFilter((pre) => ({ ...pre, status: data?.value }))}
              value={filter?.status ? paymentStatusOptions?.find((i) => i?.value == filter?.status) : { label: "", value: "" }}
            />
          </div>

          <div style={{ flex: '0 0 220px' }}>
            <CityDropdownForTrip
              label="Vendor"
              placeholder="Select Vendor"
              fetchData={fetchVendor}
              pageSize={20}
              onChange={(data) => setFilter((pre) => ({ ...pre, vendor_id: data }))}
              selectedItem={filter.vendor_id ? filter?.vendor_id : null}
            />
          </div>

          <div style={{ flex: '0 0 220px' }}>
            <CommonInput
              placeholder="Search "
              label="Search "
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
          </div>
          <button
            className="anime-btn __reSet_btn"
            disabled={isDisabled}
            onClick={handleReset}
            style={{
              backgroundColor: isDisabled ? "#ccc" : "",
              color: isDisabled ? "#666" : "white",
              cursor: isDisabled ? "not-allowed" : "pointer",
              border: "none",
              padding: "8px 16px",
              borderRadius: "6px",
              transition: "all 0.3s ease",
            }}
          >
            Reset
          </button>

        </div>
      </div>

      <div className="_tabWith_outTab">
        <BootstrapTable
          columns={columns}
          data={rowListData(purchaseBillList?.length > 0 ? purchaseBillList : [])}
          isLoading={loading}
        />

        {purchaseBillList?.length ? <div className='paginationFt_avt'>
          <CustomPagination
            totalItems={totalItems || 1}
            itemsPerPage={ITEMS_PER_PAGE}
            currentPage={filter.offset}
            onPageChange={handlePageChange}
          />
        </div> : <></>}
      </div>

      {
        isDelete?._id && (
          <CommonModal {...propsObject}>
            <p className='p-3'> Are you sure you want to delete {isDelete?.name} ?</p>
          </CommonModal>
        )
      }

    </div>
  )
}

export default PurchaseBill